module.exports = __webpack_public_path__ + "static/media/mobile_icon_1.3db91096.png";